
import { DateValue } from '@/components/ui/date-fields/types';

export function gregorianToHijri(date: DateValue) {
    try {
        // Validate input
        const y = parseInt(date.year);
        const m = parseInt(date.month);
        const d = parseInt(date.day);

        if (isNaN(y) || isNaN(m) || isNaN(d)) {
            throw new Error('Invalid date values');
        }

        // Create date object and validate
        const gregorianDate = new Date(y, m - 1, d);
        if (gregorianDate.toString() === 'Invalid Date') {
            throw new Error('Invalid date');
        }

        // Format using Intl
        const formatter = new Intl.DateTimeFormat('ar-SA-islamic-umalqura', {
            calendar: 'islamic-umalqura',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            numberingSystem: 'latn' // Use Latin numerals
        });

        const parts = formatter.formatToParts(gregorianDate);
        const values = parts.reduce((acc, part) => {
            if (part.type !== 'literal') {
                acc[part.type] = parseInt(part.value);
            }
            return acc;
        }, {} as Record<string, number>);

        return {
            year: values.year,
            month: values.month,
            day: values.day
        };
    } catch (error) {
        console.error('Gregorian to Hijri conversion error:', error);
        return null;
    }
}

export function hijriToGregorian(date: DateValue) {
    try {
        // Validate input
        const y = parseInt(date.year);
        const m = parseInt(date.month);
        const d = parseInt(date.day);

        if (isNaN(y) || isNaN(m) || isNaN(d) || 
            m < 1 || m > 12 || d < 1 || d > 30) {
            throw new Error('Invalid Hijri date');
        }

        // Use approximate conversion
        const approxJD = Math.floor((11 * y + 3) / 30) + 354 * y + 
            30 * m - Math.floor((m - 1) / 2) + d + 1948440 - 385;

        const approxDate = new Date((approxJD - 2440588) * 86400000);

        // Adjust by checking nearby dates
        for (let i = -5; i <= 5; i++) {
            const testDate = new Date(approxDate.getTime() + i * 86400000);
            const hijriTest = gregorianToHijri({
                year: testDate.getFullYear().toString(),
                month: (testDate.getMonth() + 1).toString(),
                day: testDate.getDate().toString()
            });

            if (hijriTest && 
                hijriTest.year === y && 
                hijriTest.month === m && 
                hijriTest.day === d) {
                return {
                    year: testDate.getFullYear(),
                    month: testDate.getMonth() + 1,
                    day: testDate.getDate()
                };
            }
        }

        throw new Error('Could not find matching Gregorian date');
    } catch (error) {
        console.error('Hijri to Gregorian conversion error:', error);
        return null;
    }
}
